import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import BtnExcel from '../../Components/BtnExcel';
import { 
  Layout,
  Col, 
  Row,
  Space,
  Input,
  DatePicker,
} from 'antd';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { formatAmount, getTodayDateISO, formatDate } from '../../Utils/Common';

const { RangePicker } = DatePicker;
const { Search } = Input;

const AdvanceRental = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [excelData, setExcelData] = useState([])
  const [totalAmount, setTotalAmount] = useState(0);
  const [securityData, setSecurityData] = useState([]) 

  const [filterConfig, setFilterConfig] = useState({
    date_from: "",
    date_to: "",
    search: "",
    page: 1,
  })

  async function fetchSecurityDepositeData() {
    setIsLoading(true);
    const response = await UseGetRequest("advance_rentals/get", filterConfig);
    if (response.data) {
      const deposits_date = response?.data?.data?.map((data) => ({
        id: data.id,
        tenant_id: data.tenant_id,
        amount: formatAmount(data.amount),
        date_paid: formatDate(data.date_paid),
        remarks: data.remarks,
        months: data.months,
        refunded_amount: data.refunded_amount,
        refunded_on: data.refunded_on,
        status: data.status,
        tenant_name: data.tenant_name,
        property_name: data.property_name,
        rental_unit_name: data.rental_unit_name,
      }))

      setTotalAmount(response?.data?.total)
      setPageSize(response?.data?.size)
      setSecurityData(deposits_date);
    } else {
      setTotalAmount(0)
      setPageSize('')
      setSecurityData([])
    }
    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true);
    const response = await UseGetRequest("advance_rentals/get", 
      {
        date_from: filterConfig.date_from,
        date_to: filterConfig.date_to,
        search: filterConfig.search,
      }
    );
    if (response.data) {
      const data = response?.data?.data?.map((data) => ({
        id: data.id,
        tenant_name: data.tenant_name,
        property_name: data.property_name,
        rental_unit_name: data.rental_unit_name,
        amount: data.amount && formatAmount(data.amount),
        date_paid: data.date_paid && formatDate(data.date_paid),
        payment_type: data.payment_type,
        refund_remarks: data.refund_remarks,
        refunded_amount: data.refunded_amount && formatAmount(data.refunded_amount),
        refunded_on: data.refunded_on && formatDate(data.refunded_on),
        check_no: data.check_no,
        check_date: data.check_date && formatDate(data.check_date),
        check_bank: data.check_bank,
        status: data.status,
        remarks: data.remarks,
        added_on: data.added_on,
        updated_on: data.updated_on,
      }))

      setExcelData(data)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }

  const onSearchDate = (e) => {
    if(e){
      setFilterConfig((prev) => (
        {
          ...prev,
          start_date: e[0].format("YYYY-MM-DD"),
          end_date: e[1].format("YYYY-MM-DD"),
          page: 1,
        }
      ));
    } else {
      setFilterConfig((prev) => (
        {
          ...prev,
          start_date: '',
          end_date: '',
          page: 1,
        }
      ));
    }
  };

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };
  
  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchSecurityDepositeData();
    fetchExportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'advance_rentals_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-inline responsive-tab-inline'>
          <Col span={12} className='header-container'>
            ADVANCE RENTAL
          </Col>
          <Col span={12} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "ID",
                  "Name",
                  "Property",
                  "Unit Number",
                  "Amount",
                  "Date Paid",
                  "Payment Type",
                  "Refund Remarks",
                  "Refunded Amount",
                  "Refunded On",
                  "Check No",
                  "Check Date",
                  "Checl Bank",
                  "Status",
                  "Remarks",
                  "Added On",
                  "Updated On",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Advance_Rental_${getTodayDateISO()}.xlsx`}
              />
            </Space>
          </Col>
        </Row>
        <Row>
          <Col span={24} className='excel-row'>
            <Space className='responsive-inline'>
              <Search
                placeholder="Search..."
                size='medium'
                onSearch={(e)=>handleSearchChange(e)}
                onChange={(e)=>handleEmpty(e)}
                className='responsive-header-input'
              />     
              <RangePicker 
                renderExtraFooter={() => 'extra footer'} 
                className='responsive-header-input'
                onChange={(e)=>onSearchDate(e)}
              />
            </Space>  
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='amount-total pe-4' align='right'>
            Total Amount: {formatAmount(totalAmount)}
          </Col>
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
            <AntDTable
              tableHeaders={[
                "Doc No.",
                "Tenant Name",
                "Building & Unit Number",
                "Unit Number",
                "Months",
                "Payment Date",
                "Amount",
              ]}
              headerSelector={[
                "id",
                "tenant_name",
                "property_name",
                "rental_unit_name",
                "months",
                "date_paid",
                "amount",
              ]}
              tableData={securityData}
              withAction={false}
              loading={isLoading}
              tablePages={10}
              handleTableChange={handleTableChange}
              filterConfig={filterConfig}
              totalSize={pageSize}
              isSearch={true}
            />
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default AdvanceRental
